module.exports = __webpack_public_path__ + "static/media/reddy.2ad228a0.png";